import React from 'react'
import tw from 'twin.macro'
import { Link } from 'gatsby'
import styled from 'styled-components'
import { globalHistory } from '@reach/router'
import { ReactComponent as NextButtonSvg } from '../images/next-button.svg'
import { ReactComponent as PreviousButtonSvg } from '../images/previous-button.svg'

const PaginationContainer = tw.div`mt-20 px-4 py-3 flex items-center justify-between sm:px-6`
// const MobileContainer = tw.div`flex-1 flex justify-between sm:hidden`;
const DesktopContainer = tw.div`mx-auto flex p-3 bg-white`

const PaginationNavigation = tw.nav`relative z-0 inline-flex -space-x-px`

const PaginationNextPreviousButton = tw.a`relative inline-flex items-center px-2 py-2 rounded-l-md bg-white font-bold text-gray-700 hover:bg-gray-50`
const ActiveButton = tw.a`relative inline-flex items-center px-4 py-2 bg-green-500 font-bold text-gray-100 hover:bg-green-700`
const PaginationButton = tw.a`relative inline-flex items-center px-4 py-2 bg-white font-semibold text-gray-700 hover:bg-gray-100`

const NotAllowed = styled(PaginationButton)`
  ${tw`cursor-not-allowed`}
`

const NextButton = styled(NextButtonSvg)`
  ${tw`h-5 w-5`}
`

const PreviousButton = styled(PreviousButtonSvg)`
  ${tw`h-5 w-5`}
`

function Pagination({ pageContext }) {
  const currentPath = globalHistory.location.pathname

  const hasOnlyOnePage = pageContext.numPages === 1 || currentPath === '/search'
  const isFirstPage = pageContext.currentPage === 1
  const isLastPage = pageContext.currentPage === pageContext.numPages
  const hasNumberInPath = /\d/.test(currentPath.replace('%20', ''))

  const pages = []
  let delta = 1,
    left = pageContext.currentPage - delta,
    right = pageContext.currentPage + delta + 1

  let result = Array.from(
    { length: pageContext.numPages },
    (v, k) => k + 1
  ).filter((i) => i && i >= left && i < right)

  if (result.length > 1) {
    // Add first page and dots
    if (result[0] > 1) {
      if (result[0] > 2) {
        result.unshift('...')
      }
      result.unshift(1)
    }

    // Add dots and last page
    if (result[result.length - 1] < pageContext.numPages) {
      if (result[result.length - 1] !== pageContext.numPages - 1) {
        result.push('...')
      }
      result.push(pageContext.numPages)
    }
  }

  for (let i = 0; i < result.length; i++) {
    let isCurrentPage = pageContext.currentPage === result[i]
    let isNotAllowedPage = result[i] === '...'
    let pathLinks = !hasNumberInPath
      ? './' + result[i]
      : result[i] === 1
      ? '../'
      : '../' + result[i]

    let element = isCurrentPage ? (
      <ActiveButton key={result[i]}>{result[i]}</ActiveButton>
    ) : isNotAllowedPage ? (
      <NotAllowed key={result[i]}>{result[i]}</NotAllowed>
    ) : (
      <PaginationButton as={Link} to={pathLinks} key={result[i]}>
        {result[i]}
      </PaginationButton>
    )
    pages.push(element)
  }

  const previousPagePath =
    currentPath.substring(currentPath.length - 1, currentPath.length) === '2'
      ? '../'
      : '../' +
        (currentPath.substring(currentPath.length - 1, currentPath.length) - 1)

  const nextPagePath = !hasNumberInPath
    ? './' + '2'
    : '../' +
      (+currentPath.substring(currentPath.length - 1, currentPath.length) + 1)

  //TODO: Refactor mobile container
  return (
    <PaginationContainer>
      {/*<MobileContainer>*/}
      {/*  <a*/}
      {/*    href="#"*/}
      {/*    className="relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"*/}
      {/*  >*/}
      {/*    Previous*/}
      {/*  </a>*/}
      {/*  <a*/}
      {/*    href="#"*/}
      {/*    className="ml-3 relative inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:text-gray-500"*/}
      {/*  >*/}
      {/*    Next*/}
      {/*  </a>*/}
      {/*</MobileContainer>*/}
      {!hasOnlyOnePage && (
        <DesktopContainer>
          <div>
            <PaginationNavigation aria-label="Pagination">
              {!hasOnlyOnePage && !isFirstPage && (
                <PaginationNextPreviousButton as={Link} to={previousPagePath}>
                  <span className="sr-only">Previous</span>
                  <PreviousButton />
                </PaginationNextPreviousButton>
              )}
              {!hasOnlyOnePage && pages.map((o) => o)}
              {!hasOnlyOnePage && !isLastPage && (
                <PaginationNextPreviousButton as={Link} to={nextPagePath}>
                  <span className="sr-only">Next</span>
                  <NextButton />
                </PaginationNextPreviousButton>
              )}
            </PaginationNavigation>
          </div>
        </DesktopContainer>
      )}
    </PaginationContainer>
  )
}

export default Pagination
